export const ERRORS_COPIES = {
    REQUIRED_INPUT_MISSING: 'Required inputs are missing',
    REQUIRED_INPUT: 'Required input',
    REQUIRED_NAME: 'Please enter your name',
    REQUIRED_PHONE: 'Please enter your phone number',
    REQUIRED_ORG_NAME: 'Please enter your brand name',
    REQUIRED_COURSE_CATEGORY:
      'Please choose an option closest to the topic of your courses',
    REQUIRED_PASSWORD: 'Password must be a minimum of 6 characters',
    INVALID_EMAIL: 'Please enter a valid email address',
    INVALID_PASSWORD: 'Invalid password',
    INVALID_PHONE: 'Invalid phone',
    INVALID_FILE_TYPE: 'Invalid file type',
    INVALID_FILE_QUANTITY: 'Only one file is allowed',
    REQUIRED_FILE: 'File is required',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    ENTER_VALID_DOMAIN: 'Please enter a valid domain to continue',
    ENTER_VALID_EMAIL: 'Please enter a valid email to continue',
    REQUIRED_API_KEY: 'Please enter an API key to continue',
    REQUIRED_FOR_SET_UP: '*This field is mandatory to finish setup',
    REQUIRED_ROLE: 'Please select a role for the user.',
    REQUIRED_PERMISSIONS: 'Please select at least one permission.'
  };